'use strict';

var cov_1sotyqdeg7 = function () {
  var path = 'D:\\raw\\vina_giaitri365\\vnp_365_client\\src\\app\\login\\login.js',
      hash = 'c29c137e44c28fbf04ba155c11614b9e1f5492fb',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'D:\\raw\\vina_giaitri365\\vnp_365_client\\src\\app\\login\\login.js',
    statementMap: {
      '0': {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 38,
          column: 6
        }
      },
      '1': {
        start: {
          line: 4,
          column: 18
        },
        end: {
          line: 4,
          column: 51
        }
      },
      '2': {
        start: {
          line: 5,
          column: 17
        },
        end: {
          line: 5,
          column: 50
        }
      },
      '3': {
        start: {
          line: 6,
          column: 21
        },
        end: {
          line: 9,
          column: 7
        }
      },
      '4': {
        start: {
          line: 10,
          column: 6
        },
        end: {
          line: 37,
          column: 9
        }
      },
      '5': {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 36,
          column: 9
        }
      },
      '6': {
        start: {
          line: 17,
          column: 10
        },
        end: {
          line: 17,
          column: 45
        }
      },
      '7': {
        start: {
          line: 18,
          column: 10
        },
        end: {
          line: 18,
          column: 27
        }
      },
      '8': {
        start: {
          line: 19,
          column: 10
        },
        end: {
          line: 19,
          column: 35
        }
      },
      '9': {
        start: {
          line: 20,
          column: 10
        },
        end: {
          line: 24,
          column: 13
        }
      },
      '10': {
        start: {
          line: 25,
          column: 10
        },
        end: {
          line: 28,
          column: 11
        }
      },
      '11': {
        start: {
          line: 26,
          column: 12
        },
        end: {
          line: 26,
          column: 66
        }
      },
      '12': {
        start: {
          line: 27,
          column: 12
        },
        end: {
          line: 27,
          column: 53
        }
      },
      '13': {
        start: {
          line: 29,
          column: 10
        },
        end: {
          line: 29,
          column: 47
        }
      },
      '14': {
        start: {
          line: 31,
          column: 10
        },
        end: {
          line: 35,
          column: 13
        }
      },
      '15': {
        start: {
          line: 42,
          column: 0
        },
        end: {
          line: 47,
          column: 5
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 3
          }
        },
        loc: {
          start: {
            line: 2,
            column: 155
          },
          end: {
            line: 39,
            column: 3
          }
        },
        line: 2
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 3,
            column: 19
          },
          end: {
            line: 3,
            column: 20
          }
        },
        loc: {
          start: {
            line: 3,
            column: 31
          },
          end: {
            line: 38,
            column: 5
          }
        },
        line: 3
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 15,
            column: 14
          },
          end: {
            line: 15,
            column: 15
          }
        },
        loc: {
          start: {
            line: 15,
            column: 24
          },
          end: {
            line: 37,
            column: 7
          }
        },
        line: 15
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 16,
            column: 8
          },
          end: {
            line: 36,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 16,
            column: 8
          },
          end: {
            line: 36,
            column: 9
          }
        }, {
          start: {
            line: 16,
            column: 8
          },
          end: {
            line: 36,
            column: 9
          }
        }],
        line: 16
      },
      '1': {
        loc: {
          start: {
            line: 25,
            column: 10
          },
          end: {
            line: 28,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 25,
            column: 10
          },
          end: {
            line: 28,
            column: 11
          }
        }, {
          start: {
            line: 25,
            column: 10
          },
          end: {
            line: 28,
            column: 11
          }
        }],
        line: 25
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LoginController = function LoginController($scope, myVars, $http, ngNotify, $rootScope, $httpParamSerializer, apiOpen, $state, $anchorScroll, $mdDialog, localStorageService, $mdMedia) {
  _classCallCheck(this, LoginController);

  cov_1sotyqdeg7.f[0]++;
  cov_1sotyqdeg7.s[0]++;

  $scope.login = function () {
    cov_1sotyqdeg7.f[1]++;

    var key = (cov_1sotyqdeg7.s[1]++, CryptoJS.lib.WordArray.random(16));
    var iv = (cov_1sotyqdeg7.s[2]++, CryptoJS.lib.WordArray.random(16));
    var member = (cov_1sotyqdeg7.s[3]++, {
      username: CryptoJS.AES.encrypt($scope.username, $rootScope.base64Key, { iv: $rootScope.iv }).ciphertext.toString(),
      password: CryptoJS.AES.encrypt($scope.password, $rootScope.base64Key, { iv: $rootScope.iv }).ciphertext.toString()
    });
    cov_1sotyqdeg7.s[4]++;
    $http({
      url: apiOpen + 'login',
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      transformRequest: $httpParamSerializer, data: member
    }).then(function (result) {
      cov_1sotyqdeg7.f[2]++;
      cov_1sotyqdeg7.s[5]++;

      if (result.data.status === '0') {
        cov_1sotyqdeg7.b[0][0]++;
        cov_1sotyqdeg7.s[6]++;

        myVars.msisdn = result.data.msisdn;
        cov_1sotyqdeg7.s[7]++;
        myVars.login = 1;
        cov_1sotyqdeg7.s[8]++;
        myVars.checkMember = '0';
        cov_1sotyqdeg7.s[9]++;
        ngNotify.set('Chào mừng 0' + result.data.msisdn, {
          position: 'top',
          type: 'success',
          duration: 3000
        });
        cov_1sotyqdeg7.s[10]++;
        if (localStorageService.isSupported) {
          cov_1sotyqdeg7.b[1][0]++;
          cov_1sotyqdeg7.s[11]++;

          localStorageService.set('msisdn', result.data.msisdn);
          cov_1sotyqdeg7.s[12]++;
          localStorageService.set('islogin', true);
        } else {
          cov_1sotyqdeg7.b[1][1]++;
        }
        cov_1sotyqdeg7.s[13]++;
        $state.go('app', {}, { reload: true });
      } else {
        cov_1sotyqdeg7.b[0][1]++;
        cov_1sotyqdeg7.s[14]++;

        ngNotify.set('Bạn chưa đăng ký dịch vụ hoặc mật khẩu không chính xác !', {
          position: 'top',
          type: 'error',
          duration: 3000
        });
      }
    });
  };
};

cov_1sotyqdeg7.s[15]++;


angular.module('app').component('login', {
  templateUrl: 'app/login/login.html',
  controller: LoginController
});